import { BRAND } from "../../types";
import { Traveler } from "../../types";

interface CarLicenseWarningProps {
  driver: Traveler | undefined;
}

export function CarLicenseWarning({ driver }: CarLicenseWarningProps) {
  const licenseOk = Boolean(
    driver?.licenseFront && driver?.licenseBack,
  );
  return (
    <div
      className="rounded-2xl px-4 py-3 flex items-start gap-2"
      style={{ background: "#FFF8F0", border: "1.5px solid #FFE4CC" }}
    >
      <i
        className="ri-car-line flex-shrink-0 mt-0.5"
        style={{ color: BRAND, fontSize: 14 }}
      />
      <div>
        <div
          className="text-xs font-semibold"
          style={{ color: "#92400E" }}
        >
          租车需上传驾照
        </div>
        <div className="text-xs text-gray-500 mt-0.5">
          {licenseOk
            ? `主驾「${driver.name}」驾照已上传 ✓`
            : "请在出行人员中为主驾上传驾照信息，否则无法取车"}
        </div>
      </div>
    </div>
  );
}
